<template>
  <div class="inner_content">
    <div class="header">
      <div class="flex">
        <el-button type="primary" size="small" @click="handle"
          >添加群发服务</el-button
        >
        <!-- <div class="box flex">
          <div class="title">活动状态：</div>
          <el-select
            v-model="value"
            placeholder="请选择"
            size="small"
            class="fixedwidth"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="box flex">
          <div class="title">活动日期：</div>
          <el-date-picker
            v-model="value1"
            size="small"
            class=""
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="box flex">
          <div class="title"></div>
          <el-input class="fixedwidth" size="small"></el-input>
          <el-button size="small" type="primary" placeholder="请输入活动名称"
            >查询</el-button
          >
        </div> -->
      </div>
    </div>
    <el-table
      :data="tableData"
      size="small"
      :header-cell-style="setHeader"
      height="100%"
      stripe
    >
      <el-table-column prop="listNum" label="序列" width="80">
      </el-table-column>
      <el-table-column
        prop="text"
        label="活动名称"
        width="140"
      ></el-table-column>
      <el-table-column prop="person" label="赠送对象"></el-table-column>
      <el-table-column prop="prize" label="活动奖品"></el-table-column>
      <el-table-column prop="param.remark" label="群发内容"></el-table-column>
      <el-table-column prop="time" label="发送时间"></el-table-column>
      <el-table-column prop="finishTime" label="完成时间"></el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next, jumper"
      :total="total_num"
    >
    </el-pagination>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { noticeHistory } from "@/api/market";
import time from "@/utils/time";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      page: "0",
      total_num: 0,
      tableData: [],
      form: {
        value: true,
        name: "",
        region: ""
      },
      formLabelWidth: "120px",
      dialogFormVisible: false,
      options: [
        {
          value: "0",
          label: "全部状态"
        }
      ],
      value1: "",
      value: "",
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000"
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let data = {
        app_id: this.app_id,
        token: this.token,
        page: this.page
      };
      noticeHistory(data).then(res => {
        if (res.code == 200) {
          this.tableData = res.data.data;
          this.tableData.forEach((item, index) => {
            console.log("item", item);
            item.listNum = (res.data.current_page - 1) * 10 + index;
            switch (Number(item.param.all)) {
              case 0:
                item.person = item.param.user;
                console.log("111", item.person);
                break;
              case 1:
                item.person = "全部会员";
                break;
              case 2:
                item.person = "会员标签" + item.param.tag_name;
                break;
              case 3:
                item.person = "会员等级：" + item.param.level_name;
                break;
            }
            item.prize = item.param.reward.point
              ? "赠送" + item.param.reward.point + "积分;"
              : "";
            // 优惠券
            let couponArr = item.param.reward.coupon_name
              ? item.param.reward.coupon_name.split(",")
              : [];
            let singleArr = new Set(couponArr);
            singleArr.forEach(single => {
              let num = 0;
              couponArr.forEach(much => {
                if (much == single) {
                  num += 1;
                }
              });
              item.prize += item.param.reward.coupon_name
                ? "赠送" + num + "张" + single + "优惠券;"
                : "";
            });
            // 时间戳转换
            item.time = time.setTime(item.create_time);
            item.finishTime =
              !item.complete_time || item.complete_time == null
                ? ""
                : time.setTime(item.complete_time);
          });
          this.total_num = res.data.total;
          console.log("数据", this.tableData);
        }
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getData();
    },
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    handle() {
      this.$router.push({
        path: `activeAdd`
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.inner_content {
  background: #fff;
  padding: 0 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    width: 100%;
    height: 72px;
    // margin-bottom: 20px;
    .box {
      width: 330px;
      .title {
        min-width: 100px;
        text-align: right;
      }
      .fixedwidth {
        width: 180px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .el-table {
    flex: 1;
    overflow-y: auto;
  }
  .el-pagination {
    height: 60px;
    padding-top: 16px;
  }
}
// 通用样式
.flex {
  display: flex;
  align-items: center;
  padding: 10px 0px;
}
</style>
